// COMPONENTS
import DefaultButton from "../buttons/default.button";
import FormTextInput from "../inputs/texts/form.text.input";
import { ReactComponent as PlusIcon } from "../../assets/icons/add.icon.svg";

const CLASSNAMES = {
  addButton: {
    button:
      "m-auto flex flex-row shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-2 py-2 bg-primary text-white hover:bg-secondary",
  },
  container:
    "shadow shadow-black flex flex-col bg-slate-100 border border-slate-200 rounded p-auto m-auto",
  headerContainer: "gap-2 flex flex-row border-b border-slate-200 px-2 py-1",
  inputConatiner: "gap-2 flex flex-row",
  buttonContainer: "flex",
  tableContainer: "divide-y divide-solid flex flex-col",
  rowContainer:
    "flex flex-row justify-between hover:bg-white hover:shadow hover:shadow-black",
  fieldContainer:
    "font-ubuntuRegular w-full flex flex-col justify-center items-center p-2",
  fieldLabel: "text-sm leading-none",
  fieldValue: "font-bold",
  removeButtonContainer: "flex",
  removeButton:
    "m-auto flex justify-center text-center text-2xl leading-none min-w-[30px] min-h-[30px] active:drop-shadow active:bg-secondary active:text-white text-secondary rounded-full hover:text-white hover:bg-red-500",
};

const DEFAULT_PROPS = {
  formProps: {
    fields: [],
    handleChange: () => {},
    formFields: {},
  },
  tableProps: {
    data: [],
  },
  onClickHandlers: {
    handleAdd: () => {},
    handleRemove: () => {},
  },
};

const SimpleFormAndTable = ({
  formProps = DEFAULT_PROPS.formProps,
  tableProps = DEFAULT_PROPS.tableProps,
  classNames = CLASSNAMES,
  onClickHandlers = DEFAULT_PROPS.onClickHandlers,
}) => {
  return (
    <div className={classNames?.container || CLASSNAMES.container}>
      <div
        className={classNames?.headerContainer || CLASSNAMES.headerContainer}
      >
        <div
          className={classNames?.inputConatiner || CLASSNAMES.inputConatiner}
        >
          {formProps.fields.map((prop) => (
            <FormTextInput
              key={prop.name}
              {...{
                onChange: formProps.handleChange,
                value: formProps.formFields[prop.name],
                ...prop,
              }}
            />
          ))}
        </div>
        <div
          className={classNames?.buttonContainer || CLASSNAMES.buttonContainer}
        >
          <DefaultButton
            handleClick={onClickHandlers.handleAdd}
            classNames={CLASSNAMES.addButton}
          >
            <PlusIcon className="fill-white" />
          </DefaultButton>
        </div>
      </div>
      <div className={classNames?.tableContainer || CLASSNAMES.tableContainer}>
        {tableProps.data.map((dataObject, index) => (
          <div
            key={index}
            className={classNames?.rowContainer || CLASSNAMES.rowContainer}
          >
            {formProps.fields.map((field, index) => (
              <div
                key={`${field.name}-${index}`}
                className={
                  classNames?.fieldContainer || CLASSNAMES.fieldContainer
                }
              >
                <label
                  className={classNames?.fieldLabel || CLASSNAMES.fieldLabel}
                >
                  {field.label}
                </label>
                <p className={classNames?.fieldValue || CLASSNAMES.fieldValue}>
                  {dataObject[field.name]}
                </p>
              </div>
            ))}
            <div
              className={
                classNames?.removeButtonContainer ||
                CLASSNAMES.removeButtonContainer
              }
            >
              <button
                onClick={onClickHandlers.handleRemove}
                className={classNames?.removeButton || CLASSNAMES.removeButton}
              >
                &times;
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimpleFormAndTable;
